import { useEffect } from "react"

export default function SpecialModifiers({product, modifier, hideModifier}) {

    useEffect(() => {
     
        if (
            product &&
            Array.isArray(product.metadata) &&
            product.metadata.some(
                (obj) => obj && obj.key === 'SWIFT' && obj.value === '1'
            ) 
        ) {
            if (hideModifier) {
                hideModifier(true)
            }
        }
    }, [product])

    return null
}